import React from 'react'

function CDTCategoryTab(): React.ReactElement {
  return <div>...</div>
}

export default CDTCategoryTab
